import { memo, forwardRef, FC } from 'react'
import { Input } from '@chakra-ui/react'

// type Props = InputProps & {
//   mask?: (value: string) => string
// }

type Props = any

const MaskedInput: FC<Props> = forwardRef<HTMLInputElement | null, Props>(({ onChange, mask, ...rest }, ref) => {
  if (!mask) return null

  return (
    <Input
      {...rest}
      autoComplete="off"
      ref={ref}
      onChange={(event) => {
        event.target.value = mask(event.target.value)
        if (onChange) onChange(event)
      }}
    />
  )
})

export default memo(MaskedInput)
